import { createFileRoute, redirect } from "@tanstack/react-router";
import { getCurrentUser } from "aws-amplify/auth";

export const Route = createFileRoute("/")({
  beforeLoad: async () => {
    try {
      await getCurrentUser();
    } catch {
      throw redirect({ to: "/sign-in" });
    }

    // `redirect` throws. Keep it outside the auth catch so a signed-in user
    // is not treated as unauthenticated.
    throw redirect({ to: "/balance" });
  },
});
